const MIN_MARGIN = 0.055;
export const SIZE_FACTOR = 1 - MIN_MARGIN;
export const MAX_SCREEN_SIZE = [1422 / SIZE_FACTOR, 1080 / SIZE_FACTOR]; // [width, height] in pixels
export const MOBILE_THRESHOLD = 640;
export const MOBILE_ASPECT = 390 / 640;
export const DESKTOP_ASPECT = 4 / 3;

// returns the height and width needed for an element to remain bound within a container
// element, scaled by factor (eg. 0.9 will ensure the src element doesn't take up more than
// 90% of the available space in the tightest dimension)
export const getGeometrySize = (
    containerWidth: number,
    containerHeight: number,
    srcElRatio: number,
    factor: number = 1
): [number, number] => {
    if (containerWidth > containerHeight * srcElRatio) {
        return [srcElRatio * containerHeight * factor, containerHeight * factor];
    }
    return [containerWidth * factor, (containerWidth * factor) / srcElRatio];
};
